import axiosInstance from './axiosConfig';
import { Publisher } from '../types/publisher';

export const createPublisher = async (publisher: any) => {
    const response = await axiosInstance.post<Publisher>('/publisher', publisher);
    return response?.data;
};

export const updatePublisher = async (id: number, publisher: any) => {
    const response = await axiosInstance.patch<Publisher>(`/publisher/${id}`, publisher);
    return response?.data;
}

export const getPublishers = async () => {
    const response = await axiosInstance.get<Publisher[]>('/publisher');
    return response?.data;
};

export const importPublishers = async (formData: any) => {
    const response = await axiosInstance.post<(Publisher & { errors: string[] })[]>('/publisher/import', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response?.data;
};

export const confirmImportPublishers = async (publishers: (Publisher & { errors: string[] })[]) => {
    const response = await axiosInstance.post<Publisher[]>('/publisher/confirm-import', publishers);
    return response?.data;
};